// extracted by mini-css-extract-plugin
export default {"container":"companyHome_container__nTuZw","centeredHeading":"companyHome_centeredHeading__pLReV","highlightButton":"companyHome_highlightButton__PkvgC"};